
import { Loader2 } from "lucide-react";
import { useState, useMemo } from "react";
import { useDispatch } from "react-redux";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../../Components/StakingRisk/ui/dialog";
import { CreateStakingRiskCategoryThunk, CreateStakingRiskThunk } from "../../../Store/Thunks/StakingRiskThunk";
import { Button } from "../../../Components/StakingRisk/ui/button";
import { Label } from "../../../Components/StakingRisk/ui/label";
import { Input } from "../../../Components/StakingRisk/ui/input";

export default function NewProductModal({ 
  isOpen, 
  onClose, 
  isCreating, 
  mode = "product",
  productId
}) {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const dispatch  = useDispatch();

  const config = useMemo(() => {
    const modalConfig = {
      product: {
        title: "Create New Staking Product",
        label: "Product Name",
        placeholder: "Enter product name",
        buttonText: "Create Product",
        errorText: "Product name is required",
      },
      category: {
        title: "Create New Category",
        label: "Category Name",
        placeholder: "Enter category name",
        buttonText: "Create Category",
        errorText: "Category name is required",
      },
    };

    return modalConfig[mode] || modalConfig.product;
  }, [mode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!value.trim()) {
      setError(config.errorText);
      return;
    }

    if (mode === "product") {
      dispatch(CreateStakingRiskThunk(value));
    }

    if (mode === "category") {  
      dispatch(CreateStakingRiskCategoryThunk({
    name: value,
    stakingRiskId: productId,
      }));     
    }

    setValue("");
    setError("");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{config.title}</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="name">{config.label}</Label>
              <Input
                id="name"
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setError("");
                }}
                placeholder={config.placeholder}
                autoFocus
                className={error ? "border-red-500" : ""}
              />
              {error && <p className="text-sm text-red-500">{error}</p>}
            </div>
          </div>

          <DialogFooter>
            <Button 
              type="button" 
              variant="outline" 
              onClick={onClose} 
              disabled={isCreating}
            >
              Cancel
            </Button>

            <Button type="submit" disabled={isCreating}>
              {isCreating ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Creating...
                </>
              ) : (
                config.buttonText
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}